interface IWorklistGroupVars {
	showManualActions: boolean | undefined
}

export interface IQueueItem {
	ref: string;
	groupPath: string[];
}

export interface IWorklistState {
	worklistDateRange: Array<any> | undefined,
	worklistStatusState: Array<string>,
	worklistExecutionType: string | null,
	worklistAssignee: string | null,
	worklistGroupVars: IWorklistGroupVars,
	worklistActionRefs: Array<string>,
	// Queue: snapshot of grid visual order at time of opening an action
	actionQueue: IQueueItem[],
	actionQueueIndex: number
}

const state: IWorklistState = {
	worklistDateRange: undefined,
	worklistStatusState: ['OPEN'],
	worklistExecutionType: 'MANUAL',
	worklistAssignee: null,
	worklistGroupVars: {
		showManualActions: undefined
	},
	worklistActionRefs: [],
	actionQueue: [],
	actionQueueIndex: -1
};

const mutations = {
	SET_WORKLIST_STATUS_STATE: (state, data) => {
		state.worklistStatusState = data;
	},
	SET_WORKLIST_EXECUTION_TYPE: (state, data) => {
		state.worklistExecutionType = data;
	},
	SET_WORKLIST_GROUPVARS: (state, data) => {
		state.worklistGroupVars = data;
	},
	SET_WORKLIST_DATE_RANGE: (state, data) => {
		state.worklistDateRange = data;
	},
	SET_WORKLIST_ASSIGNEE: (state, data) => {
		state.worklistAssignee = data;
	},
	SET_WORKLIST_ACTION_REFS: (state, refs: Array<string>) => {
		state.worklistActionRefs = refs;
	},
	SET_ACTION_QUEUE: (state: IWorklistState, queue: IQueueItem[]) => {
		state.actionQueue = queue;
	},
	SET_ACTION_QUEUE_INDEX: (state: IWorklistState, index: number) => {
		state.actionQueueIndex = index;
	},
	CLEAR_ACTION_QUEUE: (state: IWorklistState) => {
		state.actionQueue = [];
		state.actionQueueIndex = -1;
	}
};

const getters = {
	// Get worklist actions from actions store, ordered by worklistActionRefs
	// Filters by current status selection so UPSERT_ACTION with a new status
	// reactively hides/shows rows without a server refetch
	worklistActions: (state: IWorklistState, _getters, rootState) => {
		return state.worklistActionRefs
			.map(ref => rootState.actions.actionsByReference[ref])
			.filter(Boolean)
			.filter(action => !state.worklistStatusState?.length || state.worklistStatusState.includes(action.status));
	},

	// Queue getters
	actionQueueActive: (state: IWorklistState) => state.actionQueue.length > 0,
	actionQueuePosition: (state: IWorklistState) => state.actionQueueIndex + 1,
	actionQueueLength: (state: IWorklistState) => state.actionQueue.length,
	actionQueueCurrentItem: (state: IWorklistState) => state.actionQueue[state.actionQueueIndex] || null,
	actionQueueHasNext: (state: IWorklistState) => state.actionQueueIndex < state.actionQueue.length - 1
};

export default {
	namespaced: true,
	state,
	getters,
	mutations
};
